import utils from '../../../../../components/Organisms/Form/utils'

const config = utils.injectTranslation({
  id: 'PurposeOfTradingForm',
  path: 'onboarding.forms.CorporateAccount.PurposeOfTradingForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'briefExplanation',
            isTextarea: true,
            removeLabelEllipsis: true,
            required: true,
            textAreaHeight: '90px',
            textAreaPointerEvents: 'auto'
          },
        },
      ],
    },
  ],
})

export default config
